import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import { ReactSVG } from 'react-svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { AnchorWithLink } from 'atoms/Anchor';
import { InputBox } from 'atoms/InputBox';
import { setRedeemOffersAndPromotionsAnalyticsData } from 'organisms/OffersAndPromotions/OffersAndPromotionsUtilities/offersAndPromotionsUtils';
import { getApplicableCouponsAction, applyCoupon } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { ButtonComp, ContainedButton, ButtonType } from 'atoms/Buttons';
import {
  COUPON_APPLY_BUTTON,
  APPLIED_COUPON,
  SET_COUPON_ERROR_MESSAGE,
} from 'organisms/CouponsLanding/Constants/CouponConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateErrMsg, getToastMsg } from 'organisms/CartPage/AU/Utils/cartPageUtils';

const { ANALYTICS_EVENTS } = CART_PAGE_CONSTANTS;
/**
 * state variable to open and close the coupon landing page (Modal)
 */
const GiftCardVouchers = props => {
  const {
    bucketId = '',
    showPromoRewardsMessage = false,
    isMealFullyCovered= false,
  } = props;
  const { ADD, CANCEL, ADD_GIFT_CARD_OR_VOUCHER, ENTER_COUPON_PLACEHOLDER, CLEAR_WICODE,  MAX_VOUCHER_LIMIT_EXCEEDED, MAX_SUBTOTAL_VALUE_COVERED } = TRANSLATE_MAPPING_KEY;
  const { GiftCard_Cart, Ellipse, voucher } = IMAGE_PATH;
  const tenantData = useSelector(data => data.tenantReducer);
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const { tenantId = '', maxNoOfVoucher, currencyConversionFactor, currencySymbol } = tenantData;
  /**
   * State to determine if the screen-width falls under Mobile category
   */
  const [openModal, toggleModal] = useState(false);
  const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponErr, setcouponErr] = useState('');
  const [showCouponError, setShowCouponError] = useState(false);
  const [maxSubTotalValueCovered, setMaxSubTotalValueCovered] = useState(false);
  const [voucherLimitExceededErr, setVoucherLimitExceededErr] = useState(false);
  const dispatch = useDispatch();
  const cartReducer = useSelector(data => data.cartReducer);
  const {
    couponError,
    cartData: { discountLines = [], paymentDiscountLines = [] },
  } = cartReducer;
  const isCouponLoading = useSelector(data => data.cartReducer?.isCouponLoading);
  useEffect(() => {
    if ((!couponErr && !voucherLimitExceededErr && !maxSubTotalValueCovered) && showCouponError ) {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: '' },
      });
      setShowCouponError(false);
    }
    if ((couponError && couponError?.errorCode) || voucherLimitExceededErr || maxSubTotalValueCovered) {
      setShowCouponError(true);
      const couponErrMsg = translateErrMsg({couponError,  MAX_VOUCHER_LIMIT_EXCEEDED, voucherLimitExceededErr, maxSubTotalValueCovered, MAX_SUBTOTAL_VALUE_COVERED });
      setcouponErr(translateWithI18Next(couponErrMsg));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponError, voucherLimitExceededErr, maxSubTotalValueCovered]);
  useEffect(() => {
   if (userOrderState?.couponErrorMessage){
    userOrderStateDispatch({
      type: SET_COUPON_ERROR_MESSAGE,
      value: { couponErrorMessage: '' },
    });
    handleCloseModal()
   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderState?.couponErrorMessage]);
  const handleCloseModal = event => {
    setCouponCode('');
    setcouponErr('');
    toggleModal(false);
  };
  useEffect(() => {
    if (couponCode && !isCouponLoading && !showCouponError && applyingCoupon) {
      if (
        (paymentDiscountLines?.length &&
          paymentDiscountLines[paymentDiscountLines?.length - 1]?.status?.name?.toUpperCase() === APPLIED_COUPON) ||
        (discountLines?.length &&
          discountLines[discountLines?.length - 1]?.status?.name?.toUpperCase() === APPLIED_COUPON)
      ) {
        const couponObj = {
          discountLines,
          couponCode,
          showPromoRewardsMessage,
          currencySymbol,
          currencyConversionFactor,
          paymentDiscountLines,
        };
        getToastMsg(couponObj);     
        handleCloseModal(true);
        setCouponCode('');
        setRedeemOffersAndPromotionsAnalyticsData({
          event: ANALYTICS_EVENTS.REDEEM_OFFER,
          offerTitle: couponCode,
        });
        setApplyingCoupon(false);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponErr, paymentDiscountLines, discountLines, applyingCoupon]);

  /**
   * useEffect to dispatch action to get the applicable coupons
   */
  useEffect(() => {
    dispatch(
      getApplicableCouponsAction({
        basketId: bucketId,
        tenantId,
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    voucherLimitExceededErr &&
      !showPromoRewardsMessage &&
      !couponCode?.length &&
      setVoucherLimitExceededErr(false);
      maxSubTotalValueCovered &&
      !showPromoRewardsMessage &&
      !couponCode?.length &&
      setMaxSubTotalValueCovered(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voucherLimitExceededErr, maxSubTotalValueCovered, couponCode, showPromoRewardsMessage]);

  const inputChangeHandler = e => {
    setApplyingCoupon(false);
    setCouponCode(e.target.value);
    setcouponErr('');
  };
  const toggleApplyForm = () => {
    setCouponCode('');
    setcouponErr('');
    toggleModal(!openModal);
  };

  const couponApplyHandler = e => {
    e.stopPropagation();
    e.preventDefault();
    setApplyingCoupon(false);
    if (!showPromoRewardsMessage && paymentDiscountLines?.length >= maxNoOfVoucher) {
      setVoucherLimitExceededErr(true);
    } else if(!showPromoRewardsMessage && paymentDiscountLines?.length && isMealFullyCovered){
        setMaxSubTotalValueCovered(true);
    }
    else {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: '' },
      });
      dispatch(
        applyCoupon(
          {
            basketId: bucketId,
            tenantId,
            successCallback: () => {
              setApplyingCoupon(true);
              toggleModal(false);
              setCouponCode('');
            },
          },
          {
            couponCode: couponCode,
          },
        ),
      );
      setCouponCode(couponCode);
    }
  };

  /**
   * To Clear the Coupon Input Field
   */
  const clearSearch = () => {
    setCouponCode('');
    setcouponErr('');
  };
  const imageSrc = showPromoRewardsMessage ? voucher : GiftCard_Cart;
  return (
    <div className='main-wicode-container'>
      <div
        className={`cart-offers-container ${!showPromoRewardsMessage && 'cart-coupon-wicode-offers-container'}`}
        data-testid='cart-offers-coupon'
      >
        <div className='cart-wicode-offers-link'>
          <ReactSVG src={imageSrc} alt='' className='cart-offers-icon' />
          <span className='cart-wicode-offers-text'>{translateWithI18Next(ADD_GIFT_CARD_OR_VOUCHER)}</span>
        </div>
        <AnchorWithLink
          onClickHandler={() => toggleApplyForm()}
          ariaLable='View all offers'
          className='add-gift-card-voucher'
          data-testid={openModal ? 'offers-toggle-btn-off' : 'offers-toggle-btn-on'}
        >
          {!openModal ? translateWithI18Next(ADD) : translateWithI18Next(CANCEL)}
        </AnchorWithLink>
        
      </div>
      {openModal && (
        <div className='coupon-code-validation-container'>
          <div className='coupon-discount-col-2'>
            <label
              data-testid='coupon-input-label'
              className={`coupon-input-label ${couponCode?.length && 'coupon-input-label-focus'}`}
              htmlFor='modal-coupon-input'
            >
              {translateWithI18Next(ENTER_COUPON_PLACEHOLDER)}
            </label>
            <div className='flex-input-section'>
              <InputBox
                id='modal-coupon-input'
                value={couponCode}
                className={`coupon-text-box ${
                  couponErr && 'coupon-text-box-err'
                }`}
                placeholder={translateWithI18Next(ENTER_COUPON_PLACEHOLDER)}
                data-testid='modal-coupon-input-field'
                onChange={inputChangeHandler}
                disabled={isCouponLoading}
              />
              {couponCode.length > 0 && (
                <ButtonComp
                  data-testid='coupon-cross-icon'
                  className={!isCouponLoading ? 'discount-button-img' : 'discount-button-img-disable'}
                  onClick={() => clearSearch()}
                  onKeyPress={() => clearSearch()}
                  aria-label={translateWithI18Next(CLEAR_WICODE)}
                ></ButtonComp>
              )}
            </div>
            {couponErr && (
              <div role='alert'>
                <img className='' src={Ellipse} alt='invalid' />{' '}
                <span data-testid='coupon-err-msg' className='error-msg error-container-coupon'>
                  {couponErr}
                </span>
              </div>
            )}
          </div>
          <div className='coupon-discount-col-3'>
            <ContainedButton
              variant={ButtonType.primary}
              aria-label={translateWithI18Next(COUPON_APPLY_BUTTON)}
              id='btn-apply-view'
              data-testid='coupon-apply-btn'
              className='button whiteButton blackBorder coupon-button'
              disabled={!couponCode?.length || couponErr}
              onClickHandler={e => couponApplyHandler(e)}
              loading={isCouponLoading}
            >
              {!isCouponLoading && translateWithI18Next(COUPON_APPLY_BUTTON)}
            </ContainedButton>
          </div>
          {!paymentDiscountLines?.length && <hr />}
        </div>
      )}
    </div>
  );
};

export default GiftCardVouchers;
